import { useCallback, useEffect, useState } from "react";
import Constants from "../Constants";
import useAxios from "./useAxios";


const useHistogram = () => {
    const { getData } = useAxios();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [showEntries, setShowEntries] = useState(200);
    const [promptId, setPromptId] = useState([]);
    const [isTokenInput, setIsTokenInput] = useState(false)
    const [isPromptListLoading, setIsPromptListLoading] = useState(false);


    const fetchUniquePrompt = useCallback(async () => {
        const params = new URLSearchParams({
            page: currentPage,
            limit: showEntries,
            isInputTokens: isTokenInput
        });
        setIsPromptListLoading(true)
        const baseUrl = Constants.ApiUrl.super.dashboard.promptId;
        const response = await getData(`${baseUrl}?${params.toString()}`);

        if (response?.success) {
            setPromptId(response.data.items || []);
            setTotalCount(response.data.pageSize || 0);
            setTotalPages(Math.ceil((response.data.total || 0) / showEntries));
        }
        setIsPromptListLoading(false)
        
    }, [currentPage, showEntries, getData, isTokenInput]);

    useEffect(() => {
        fetchUniquePrompt();
    }, [fetchUniquePrompt]);

    const fetchDatabyPromptId = async (promptId) => {
        if (!promptId) return [];
        const baseUrl = Constants.ApiUrl.super.dashboard.promptId;
        const response = await getData(`${baseUrl}/${promptId}/tokens?isInputTokens=${isTokenInput}`);
        return response?.success ? (response.data || []) : [];
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return {
        promptId,
        showEntries,
        totalCount,
        currentPage,
        totalPages,
        handlePageChange,
        setShowEntries,
        fetchDatabyPromptId,
        isPromptListLoading,
        isTokenInput,
        setIsTokenInput

    };
};


export default useHistogram;